
import { useCallback, useEffect, useState } from 'react';
import { Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import { userLogin, getProfile } from '../../api/loginApi';
import { useSelector, useDispatch } from 'react-redux';
import { setToken, setIsLoginCompleted, setUserInfo } from '../../redux/userSlice'

export const useLogin = props => {

    const navigate = useNavigate();

    const [form] = Form.useForm();

    const dispatch = useDispatch()

    const [clientReady, setClientReady] = useState(false);
    const [loginLoading, setLoginLoading] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        localStorage.removeItem("ADMIN_LOGIN_TOKEN");
        setClientReady(true);
    }, []);

    const onStartLogin = useCallback((values) => {
        setLoginLoading(true);
        userLogin(values).then(res => {
            console.log('res', res);

            setLoginLoading(false);
            if (res && res.response.isSuccess) {
                localStorage.setItem("userLocalData", JSON.stringify(values));
                localStorage.setItem("ADMIN_LOGIN_TOKEN", res.token);
                dispatch(setToken(res.token))

                // getProfile
                getProfile().then(resProfile => {
                    // console.log('resProfile', resProfile);
                    if (resProfile && resProfile.response.isSuccess) {
                        dispatch(setUserInfo(resProfile.user))
                        dispatch(setIsLoginCompleted(true))
                    } else {
                        dispatch(setIsLoginCompleted(true))
                        setShowErrorMsg(true);
                        setErrorMsg(resProfile.response.errorMessage);
                    }

                    navigate('/', { replace: true })

                }).catch(error => {
                    dispatch(setIsLoginCompleted(true))
                    console.error(error)
                })



            } else {
                setShowErrorMsg(true);
                setErrorMsg(res.response.errorMessage);
            }
        }).catch(error => {
            console.error(error)
            setLoginLoading(false);
        })

    }, [navigate, form]);

    useEffect(() => {
        const userLocalData = localStorage.getItem("userLocalData");
        if (userLocalData) {
            const userSaveData = JSON.parse(userLocalData);
            if (userSaveData && userSaveData.remember) {
                form.setFieldsValue(userSaveData)
            }
        }
    }, []);


    const handleForgetPassWord = useCallback(() => {
        navigate('/forgetpassword', { replace: false })
    })


    return {
        form,
        clientReady,
        loginLoading,
        onStartLogin,
        errorMsg,
        showErrorMsg,
        setShowErrorMsg,
        handleForgetPassWord
    };

}